import React, { ReactElement } from 'react'
import debounce from 'lodash/debounce'

import { NavLinkData } from '@mindfulchefuk/features/Navigation/interfaces'
import { NavItem } from '@mindfulchefuk/features/Navigation/components/Header/shared'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'
import { Box } from '@mindfulchefuk/design-system'
import { useSignedOutNavDesktopContext } from '../../context/SignedOutNavDesktopContext'
import { SignedOutNavDropDown } from '../SignedOutNavDropDown'

type TSignedOutNavLinksWithSubLinks = {
  link: NavLinkData
}

export const SignedOutNavLinksWithDropdown = ({
  link,
}: TSignedOutNavLinksWithSubLinks): ReactElement => {
  const { activeItem, setActiveItem, setIsHovered, isHovered } =
    useSignedOutNavDesktopContext()
  const debouncedHandleMouseEnter = debounce(() => setIsHovered(true), 400)

  const isActive = activeItem === link.id

  return (
    <Box key={link.id}>
      <NavItem
        hasSubMenu
        id={link.id}
        href={link.subNav[0].href}
        active={isActive}
        onMouseEnter={() => {
          setActiveItem(link.id)
          debouncedHandleMouseEnter()
        }}
        onClick={() =>
          trackAnalyticsEvent({
            name: 'nav link clicked',
            data: {
              'link name': link.label,
              section: 'top nav',
              'page source': 'homepage',
            },
          })
        }
      >
        {link.label}
      </NavItem>
      {isActive && isHovered && <SignedOutNavDropDown {...link} />}
    </Box>
  )
}
